import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

interface IState {
  isImporting: boolean;
  websiteUrl: string | null;
}

interface IActions {
  setIsImporting: (value: boolean) => void;
  setWebsiteUrl: (value: string | null) => void;
  reset: () => void;
}

const initState: IState = {
  isImporting: false,
  websiteUrl: null,
};

export const useMediaLibWebsiteStore = create<IState & IActions>((set) => ({
  ...initState,
  setIsImporting: (isImporting) => set({ isImporting }),
  setWebsiteUrl: (websiteUrl) => set({ websiteUrl }),
  reset: () => set(initState),
}));

export const useMediaLibWebsiteStoreShallow = <U>(
  selector: (store: IState & IActions) => U,
) => {
  return useMediaLibWebsiteStore(useShallow(selector));
};
